import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from '@angular/router';
import { AppPublicComponent } from "./app-public.component";

const routes: Routes = [
    {
        path: 'visualidentification',        
        loadChildren: () => import('./visual-identification/visual-identification.module').then(m => m.VisualIdentificationModule)
    },
    {
        path: 'form-designer',        
        loadChildren: () => import('./form-designer/form-designer.module').then(m => m.FormDesignerModule)
    },
    {
        path: 'staff-map-tracking',
        loadChildren: () => import('./staff-map-tracking/staff-map-tracking.module').then(s => s.StaffMapTrackingModule)
    }
    
    
]

@NgModule({
    declarations: [],
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AppPublicRoutingModule {}